import * as React from "react";
import type { SVGProps } from "react";
const SvgReceiptWithEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.53 16.28a4.001 4.001 0 0 1-3-1.42 5.208 5.208 0 0 1-.796-1.28H8.21a1 1 0 0 1 0-2h.091a4.875 4.875 0 0 1 0-.16H8.21a1 1 0 0 1 0-2h.523c.188-.432.435-.84.737-1.21a4 4 0 0 1 3-1.49 4 4 0 0 1 3.06 1.42 1 1 0 0 1-.1 1.41A1 1 0 0 1 14 9.46a2 2 0 0 0-1.51-.74 2 2 0 0 0-1.425.7h1.465a1 1 0 1 1 0 2h-2.217a3.55 3.55 0 0 0 0 .16h2.217a1 1 0 0 1 0 2h-1.455A2 2 0 0 0 14 13.5a1 1 0 0 1 1.41-.09 1 1 0 0 1 .1 1.41 4 4 0 0 1-2.98 1.46Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 22a1 1 0 0 1-.71-.29L12 20.41l-1.29 1.3a1.002 1.002 0 0 1-1.42 0l-1.42-1.42-2.32 1.54a1 1 0 0 1-1 .05A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-.53.88 1 1 0 0 1-1-.05l-2.32-1.54-1.42 1.42A1.002 1.002 0 0 1 14 22Zm-2-4a1 1 0 0 1 .71.29l1.29 1.3 1.29-1.3a1 1 0 0 1 1.26-.12l1.45 1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.13l1.45-1a1 1 0 0 1 1.26.12l1.29 1.3 1.29-1.3A1 1 0 0 1 12 18Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReceiptWithEuro;
